import { Exercise } from "@/Components/Exercises/exerciseSchema";
import {
    ExercisesSeenContext,
    initialExercisePickerContext,
} from "@/Contexts/ExercisesSeenContext";
import { PageProps } from "@/types/page";
import { usePage } from "@/utils/turboSafeInertia";
import axios from "axios";
import { PropsWithChildren, useEffect, useState } from "react";

export function ExercisesSeenProvider({ children }: PropsWithChildren) {
    const { user, twoFactorPassed } = usePage<PageProps>().props;
    const [unseenExercises, setUnseenExercises] = useState(
        initialExercisePickerContext.unseenExercises,
    );

    const unseenExercisesTotal = Object.values(unseenExercises).length;

    const setSeen = async (exerciseId: Exercise["id"]) => {
        if (user?.type !== "coach") return;
        if (!unseenExercises[exerciseId]) return;
        await axios.post(
            route("exercise-seen-by-coach.markAsSeen", {
                exercise: exerciseId,
            }),
        );
        setUnseenExercises((prev) => {
            const newState = { ...prev };
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete newState[exerciseId];
            return newState;
        });
    };

    const getUnseen = async () => {
        if (user?.type !== "coach") return;
        const { data } = await axios.get(
            route("exercise-seen-by-coach.getUnseen"),
        );
        setUnseenExercises(data);
    };

    useEffect(() => {
        if (user?.type !== "coach" || !twoFactorPassed) return;
        getUnseen();
    }, [user?.type, user?.id, twoFactorPassed]);

    return (
        <ExercisesSeenContext.Provider
            value={{
                unseenExercises,
                setSeen,
                unseenExercisesTotal,
            }}
        >
            {children}
        </ExercisesSeenContext.Provider>
    );
}
